export const fetchSummary = (state, summary) => {
    state.summary = summary;
};

export const getDashboard = (state, dashboard) => {
    state.dashboard = dashboard;
};

export const getBalances = (state, balances) => {
    state.balances = balances
}

export const setWalletOverview = (state, walletOverview) => {
    state.walletOverview = walletOverview
}

const MetricsMutation = {
    fetchSummary,
    getDashboard,
    getBalances,
    setWalletOverview
};

export default MetricsMutation;